/**
 * The rules a create form checks as you type. A rule is shown only once something breaks it (Milos 2026-10-26: "Should
 * report only if someone tries to put something wrong"), never as standing text. The limits mirror the backend's
 * validators (backend/src/validators/index.ts): names are lowercase letters, digits and hyphens; every generated-if-empty
 * secret is at least 8 characters; MySQL and ClickHouse passwords also allow only letters, digits, _ and -.
 */

export const NAME_RULE = 'Lowercase letters, numbers and hyphens only.';

/** The name as typed, cleaned; `rejected` when a character was dropped (capitals are lowered, not rejected). */
export function cleanName(raw: string): { value: string; rejected: boolean } {
    const lower = raw.toLowerCase();
    const value = lower.replace(/[^a-z0-9-]/g, '');
    return { value, rejected: value !== lower };
}

export const SECRET_MIN = 8;
export const SECRET_CHARSET_RULE = 'Letters, numbers, _ and - only.';
const OUTSIDE_CHARSET = /[^A-Za-z0-9_-]/;

/**
 * What is wrong with a typed secret, or null. Empty is fine: one is generated. A character the backend refuses shows at
 * once; a short one only after the field is left, so it does not nag while still being typed.
 */
export function secretProblem(value: string, opts: { charset?: boolean; left?: boolean } = {}): string | null {
    if (!value) return null;
    if (opts.charset && OUTSIDE_CHARSET.test(value)) return SECRET_CHARSET_RULE;
    if (value.length < SECRET_MIN) return opts.left ? `At least ${SECRET_MIN} characters.` : null;
    return null;
}

/** Whether the form may send it (a short one counts, whether or not the field was left yet). */
export function secretOk(value: string, opts: { charset?: boolean } = {}): boolean {
    return !value || (value.length >= SECRET_MIN && !(opts.charset && OUTSIDE_CHARSET.test(value)));
}
